import { createGlobalStyle } from 'styled-components';

import introFontWoff2URL from '../../../../assets/fonts/IntroRegular.woff2';
import introFontWoffURL from '../../../../assets/fonts/IntroRegular.woff';
import introFontTtfURL from '../../../../assets/fonts/IntroRegular.ttf';
import introBoldWoff2URL from '../../../../assets/fonts/IntroBold.woff2';
import introBoldWoffURL from '../../../../assets/fonts/IntroBold.woff';
import introBoldTtfURL from '../../../../assets/fonts/IntroBold.ttf';

export default createGlobalStyle`
@font-face {
  font-family: 'Intro';
  src: url(${introFontWoff2URL}) format('woff2'),
    url(${introFontWoffURL}) format('woff'),
    url(${introFontTtfURL}) format('truetype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'Intro';
  src: url(${introBoldWoff2URL}) format('woff2'),
    url(${introBoldWoffURL}) format('woff'),
    url(${introBoldTtfURL}) format('truetype');
  font-weight: bold;
  font-style: normal;
}

body {
  ${props => ({ ...props.theme.typography.body1 })}
  margin: 0px;
  box-sizing: border-box;
  background: ${props => props.theme.colors.background.default};
  height: auto; /* This is to override 100% height from the old css */
};

a {
  text-decoration: none;
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  color: ${props => props.theme.colors.text.primary};
}

h1 {
  ${props => ({ ...props.theme.typography.h1 })};
}

h2 {
  ${props => ({ ...props.theme.typography.h2 })};
}

h3 {
  ${props => ({ ...props.theme.typography.h3 })};
}

h4 {
  ${props => ({ ...props.theme.typography.h4 })};
}

h5 {
  ${props => ({ ...props.theme.typography.h5 })};
}

h6 {
  ${props => ({ ...props.theme.typography.h6 })};
}
`;
